import { useMutation, useQueryClient } from '@tanstack/react-query';

import { onboardingApi } from 'entities/onboarding/api/onboardingApi';
import { onboardingKeys } from 'entities/onboarding/api/queryKeys';
import type { SetupRequest } from 'entities/onboarding/types';

export function useOnboardingSetup() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: SetupRequest) => onboardingApi.setup(data),
    // Return the promise so the mutation stays pending until state + checklist refetch, matching
    // useChecklist; otherwise the next step can read stale cache.
    onSuccess: () =>
      Promise.all([
        queryClient.invalidateQueries({ queryKey: onboardingKeys.state() }),
        queryClient.invalidateQueries({ queryKey: onboardingKeys.checklist() }),
      ]),
  });
}
